import { ModelItem } from "..";

export const ItemsOrder = (i1: ModelItem, i2: ModelItem) => {
    return i1.order - i2.order;
}